import Header from "components/Header/Header"
import AppButton from "components/StyledComponents/AppButton"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import React, { Fragment, useEffect, useState } from "react"
import { Container, Row, Col } from "react-bootstrap"
import CreateIcon from "@mui/icons-material/Create"
import { useDispatch, useSelector } from "react-redux"
import classes from "../menu.module.scss"
import {
  getReviewBarMenuPeriodAction,
  getReviewMenuPeriodAction,
  getReviewWineMenuPeriodAction,
  getReviewSpiritCMSAction,
  getReviewMenuSubCategoryAction,
  getReviewMenuCategoriesAction,
  publishReviewMenuAction
} from "redux/marketing/actions"
import { Grid, InputAdornment, Typography, useTheme } from "@mui/material"
import { useHistory } from "react-router-dom"
import MenuNavBar from "components/menuNavBar"
import SubMenuBar from "components/subMenuBar"
import WineListItems from "components/WineListItems"
import BarListItems from "components/BarListItem"
import { getNewSpiritCountAction } from "redux/marketing/actions/user"
import SpiritsMenuListContainer from "components/spiritsMenuListConatiner"
import SpiritsSubMenuBar from "components/SpiritsSubMenuBar"
import DMV_SpiritSummary from "components/DMVSpiritSummary"
import { useDebounce } from "hooks/utils"
import SearchTextField from "components/StyledComponents/SearchTextField"
import SearchIcon from "@mui/icons-material/Search"
import WineBottleListItems from "components/WineBottleListItems"
import { Masonry } from "@mui/lab"
import MenuListContainer from "components/menuListContainer"
import { marketingActions } from "redux/marketing/slice/user"

const menuText = {
  BARMENU: "bar menu",
  WINEBAR: "wine by glass",
  WINEBOTTLE: "wine by bottle",
  DINNER: "dinner",
  LUNCH: "lunch",
  BRUNCH: "brunch",
  BREAKFAST: "breakfast",
  SPIRITS: "spirits",
  SPECIALS: "specials"
}

function MenuReview() {
  const [breadCrumbs, setBreadcrumbs] = useState([])
  const dispatch = useDispatch()
  const history = useHistory()
  const theme = useTheme()
  const { linkCategory } = useSelector((state) => state?.marketing?.menu || {})
  const {
    reviewMenuPeriod,
    reviewBarMenuPeriod,
    reviewWineMenuPeriod,
    reviewSpiritData,
    reviewMenuSubCategory
  } = useSelector((state) => state?.marketing?.menu || {})
  const { isLoading } = useSelector((store) => store.app)
  const { menuCategory, SpiritSubMenu } = useSelector((state) => state.dmv)
  const [searchValue, setSearchValue] = useState("")
  const debouncedSearchTerm = useDebounce(searchValue, 500)
  const [menuItems, setMenuItems] = useState(reviewMenuPeriod)
  const [barItems, setBarItems] = useState(reviewBarMenuPeriod)
  const [wineItems, setWineItems] = useState(reviewWineMenuPeriod)
  const [spiritItems, setSpiritItems] = useState(reviewSpiritData)

  const handleSearchField = (e) => {
    setSearchValue(e.target.value)
  }

  const handleEditRouting = () => {
    const itemsLink = {
      item: linkCategory?.item,
      category: linkCategory?.category,
      list: "Detailed View"
    }
    dispatch(marketingActions.setMenuLink(itemsLink))
    history.push("/marketing/dashboard/explore-menu/review-menu/edit")
  }

  useEffect(() => {
    setBreadcrumbs(createBreadcrumbs())
    dispatch(getReviewMenuCategoriesAction())
    document.title = "Review Menu"
  }, [])

  useEffect(() => {
    if (linkCategory?.item === menuText.BARMENU) {
      dispatch(getReviewBarMenuPeriodAction())
    } else if (
      linkCategory?.item === menuText.WINEBAR ||
      linkCategory?.item === menuText.WINEBOTTLE
    ) {
      dispatch(getReviewWineMenuPeriodAction())
    } else if (linkCategory?.item === menuText.SPIRITS) {
      dispatch(getReviewSpiritCMSAction())
      dispatch(getNewSpiritCountAction())
    } else {
      dispatch(getReviewMenuSubCategoryAction())
      dispatch(getReviewMenuPeriodAction())
    }
    setSearchValue("")
  }, [linkCategory?.item, linkCategory?.category])

  function filterResults(searchQuery, results, menuType) {
    const trimmedQuery = searchQuery.trim().toLowerCase()

    if (!trimmedQuery) {
      return results
    }

    const isSpiritsMenu = menuType === menuText.SPIRITS
    const listKey = isSpiritsMenu ? "spirit_list" : "food_list"
    const categoryKey = isSpiritsMenu ? "spirit_category" : "food_category"

    return results
      ?.map((period) => {
        const category = period[categoryKey]?.toLowerCase()
        const isCategoryMatch = category.includes(trimmedQuery)

        // If the search query partially matches the category, return all items in that category
        if (isCategoryMatch) {
          return period
        }

        // Filter items by name or by ingredients
        const filteredList = period[listKey]?.filter((item) => {
          const nameMatch = item?.name?.toLowerCase().includes(trimmedQuery)
          let fieldMatches
          if (isSpiritsMenu) {
            const searchableFields = [
              "description",
              "origin",
              "unique_facts",
              "ingredient",
              "nose",
              "palate",
              "finish",
              "distillation",
              "aging",
              "bottling"
            ]

            fieldMatches = searchableFields.some((field) => {
              if (typeof item[field] === "string") {
                return item[field].toLowerCase().includes(trimmedQuery)
              }

              if (Array.isArray(item[field])) {
                return item[field].some((value) => {
                  if (typeof value === "string") {
                    return value.toLowerCase().includes(trimmedQuery)
                  } else if (typeof value === "object" && value?.fact) {
                    return value.fact.toLowerCase().includes(trimmedQuery)
                  } else if (typeof value === "object" && value?.name) {
                    return value.name.toLowerCase().includes(trimmedQuery)
                  }
                  return false
                })
              }
              return false
            })
          }

          // Dynamically search in the data_to_display fields
          const dataFieldMatch = item?.data_to_display?.some((field) => {
            const fieldValue = field?.value

            if (typeof fieldValue === "string") {
              return fieldValue.toLowerCase().includes(trimmedQuery)
            }

            // If the value is an array, search within the array elements (e.g., allergens or ingredients)
            if (Array.isArray(fieldValue)) {
              return fieldValue.some((value) => {
                if (typeof value === "string") {
                  return value.toLowerCase().includes(trimmedQuery)
                } else if (typeof value === "object" && value?.name) {
                  return value.name.toLowerCase().includes(trimmedQuery)
                }
                return false
              })
            }

            if (typeof fieldValue === "object" && fieldValue?.name) {
              return fieldValue.name.toLowerCase().includes(trimmedQuery)
            }

            return false
          })

          return nameMatch || dataFieldMatch || fieldMatches
        })

        return filteredList?.length > 0 ? { ...period, [listKey]: filteredList } : null
      })
      .filter(Boolean)
      .sort((a, b) => {
        const categoryA = a[categoryKey].toLowerCase()
        const categoryB = b[categoryKey].toLowerCase()

        // Sort based on how closely the category matches the query
        if (categoryA === trimmedQuery) return -1
        if (categoryB === trimmedQuery) return 1

        if (categoryA.startsWith(trimmedQuery) && !categoryB.startsWith(trimmedQuery)) return -1
        if (!categoryA.startsWith(trimmedQuery) && categoryB.startsWith(trimmedQuery)) return 1

        return categoryA.localeCompare(categoryB)
      })
  }

  useEffect(() => {
    const menuMap = {
      [menuText.BARMENU]: {
        data: reviewBarMenuPeriod,
        setFunction: setBarItems
      },
      [menuText.WINEBAR]: {
        data: reviewWineMenuPeriod,
        setFunction: setWineItems
      },
      [menuText.WINEBOTTLE]: {
        data: reviewWineMenuPeriod,
        setFunction: setWineItems
      },
      [menuText.SPIRITS]: {
        data: reviewSpiritData,
        setFunction: setSpiritItems
      },
      default: {
        data: reviewMenuPeriod,
        setFunction: setMenuItems
      }
    }

    const { data, setFunction } = menuMap[linkCategory?.item] || menuMap.default
    const filteredResults = filterResults(debouncedSearchTerm, data, linkCategory?.item)
    setFunction(filteredResults)
  }, [
    reviewBarMenuPeriod,
    reviewWineMenuPeriod,
    reviewSpiritData,
    reviewMenuPeriod,
    linkCategory?.item,
    menuCategory?.name,
    linkCategory?.category,
    debouncedSearchTerm
  ])

  const [selectedItems, setSelectedItems] = useState([])

  const handleToggleItem = (id) => {
    setSelectedItems((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id)
      } else {
        return [...prev, id]
      }
    })
  }

  const handleSaveDraft = () => {
    history.push("/marketing/dashboard/explore-menu")
  }

  const handlePublish = () => {
    const payload = {
      is_all_selected: false,
      item_ids: selectedItems,
      excepted_ids: [],
      item_state: "available"
    }
    dispatch(
      publishReviewMenuAction({
        payload,
        onSuccess: () => {
          history.push("/marketing/dashboard/explore-menu")
        }
      })
    )
  }

  return (
    <Fragment>
      <Container fluid className="p-0">
        <Row>
          <Col lg="12">
            <Header title={`Review Menu`} breadCrumbs={breadCrumbs}>
              <Grid container spacing={2}>
                <Grid item mt={2}>
                  <Typography
                    variant="body1Regular"
                    onClick={handleSaveDraft}
                    sx={{
                      color: theme.palette.secondary.main,
                      textDecoration: "underline",
                      margin: "10px 20px",
                      cursor: "pointer",
                      textUnderlineOffset: "3px"
                    }}>
                    Save Draft
                  </Typography>
                </Grid>
                <Grid item>
                  <AppButton
                    sx={{ padding: "13px 50px" }}
                    onClick={handlePublish}
                    disabled={selectedItems.length === 0}>
                    Publish
                  </AppButton>
                </Grid>
                <Grid item>
                  <AppButton onClick={handleEditRouting}>
                    <CreateIcon
                      sx={(theme) => ({ color: theme.palette.secondary.main })}
                      className="me-2"></CreateIcon>
                    Edit Menu
                  </AppButton>
                </Grid>
              </Grid>
            </Header>
          </Col>
        </Row>
        <Row>
          <Col lg="12">
            <MenuNavBar
              isReviewMode={true}
              activeTab={linkCategory?.item}
              subCategory={reviewMenuSubCategory?.[0]?.name}
            />
          </Col>
        </Row>
        {(linkCategory?.item === menuText.DINNER ||
          linkCategory?.item === menuText.LUNCH ||
          linkCategory?.item === menuText.BRUNCH ||
          linkCategory?.item === menuText.BREAKFAST ||
          linkCategory?.item === menuText.SPECIALS) && (
          <Row className="mt-4">
            <Col lg="12">
              <SubMenuBar
                isReviewMode={true}
                activeTab={linkCategory?.category}
                menu={reviewMenuSubCategory}
              />
            </Col>
          </Row>
        )}
        {linkCategory?.item === menuText.SPIRITS && (
          <Row className="mt-4">
            <Col lg={12}>
              <SpiritsSubMenuBar isCMS={true} activeTab={menuCategory?.name} />
            </Col>
          </Row>
        )}
        <Row className="mt-4">
          <Col lg="4">
            <SearchTextField
              id="search"
              name="search"
              value={searchValue}
              onChange={handleSearchField}
              fullWidth
              type="search"
              placeholder="Search menu items or ingredients"
              InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <InputAdornment
                    position="end"
                    sx={{
                      backgroundColor: theme.palette.primary.main
                    }}>
                    <SearchIcon htmlColor={`${theme.palette.text.secondary}`} />
                  </InputAdornment>
                )
              }}
              style={{
                border: `1px solid ${theme.palette.text.secondary}`,
                backgroundColor: theme.palette.primary.main,
                borderRadius: 6
              }}
            />
          </Col>
        </Row>
      </Container>
      {linkCategory?.item !== menuText.BARMENU &&
        linkCategory?.item !== menuText.SPIRITS &&
        linkCategory?.item !== menuText.WINEBOTTLE &&
        linkCategory?.item !== menuText.WINEBAR && (
          <Container fluid className="p-0 mt-4">
            <Masonry columns={2} spacing={2}>
              {menuItems?.length > 0 ? (
                menuItems?.map((menuItem, idx) => {
                  return (
                    <MenuListContainer
                      data={menuItem}
                      key={idx}
                      isReviewMode={true}
                      selectedItems={selectedItems}
                      handleToggleItem={handleToggleItem}
                    />
                  )
                })
              ) : (
                <Typography>
                  {searchValue
                    ? "No items found matching your search"
                    : isLoading
                    ? "Please wait, we are fetching the menu items..."
                    : "No Data Found"}
                </Typography>
              )}
            </Masonry>
          </Container>
        )}
      {linkCategory?.item === menuText.BARMENU && (
        <Container fluid className="p-0 mt-4">
          <Masonry columns={2} spacing={2}>
            {barItems?.length > 0 ? (
              barItems?.map((menuItem, idx) => {
                return (
                  <BarListItems
                    data={menuItem}
                    key={idx}
                    isReviewMode={true}
                    selectedItems={selectedItems}
                    handleToggleItem={handleToggleItem}
                  />
                )
              })
            ) : (
              <Typography>
                {searchValue ? "No items found matching your search" : "No Data Found"}
              </Typography>
            )}
          </Masonry>
        </Container>
      )}
      {linkCategory?.item === menuText.WINEBAR && (
        <Container fluid className="p-0 mt-4">
          <Masonry columns={2} spacing={2}>
            {wineItems?.length > 0 ? (
              wineItems?.map((menuItem, idx) => {
                return (
                  <WineListItems
                    data={menuItem}
                    key={idx}
                    isReviewMode={true}
                    selectedItems={selectedItems}
                    handleToggleItem={handleToggleItem}
                  />
                )
              })
            ) : (
              <Typography>
                {searchValue ? "No items found matching your search" : "No Data Found"}
              </Typography>
            )}
          </Masonry>
        </Container>
      )}
      {linkCategory?.item === menuText.WINEBOTTLE && (
        <Container fluid className="p-0 mt-4">
          <Masonry columns={2} spacing={2}>
            {wineItems?.length > 0 ? (
              wineItems?.map((menuItem, idx) => {
                return (
                  <WineBottleListItems
                    data={menuItem}
                    key={idx}
                    isReviewMode={true}
                    selectedItems={selectedItems}
                    handleToggleItem={handleToggleItem}
                  />
                )
              })
            ) : (
              <Typography>
                {searchValue ? "No items found matching your search" : "No Data Found"}
              </Typography>
            )}
          </Masonry>
        </Container>
      )}
      {linkCategory?.item === menuText.SPIRITS && (
        <>
          <Grid item sx={{ maxWidth: "50%" }}>
            {SpiritSubMenu?.map(
              (foodList, i) =>
                foodList?.id === menuCategory?.name &&
                (foodList?.description ||
                  foodList?.image_url ||
                  foodList?.unique_facts?.length > 0) && (
                  <DMV_SpiritSummary key={i} isEdit={false} foodList={foodList} isCMS={true} />
                )
            )}
          </Grid>
          <Container fluid className="p-0 mt-4">
            <div className={classes.spiritContainer}>
              {spiritItems?.length > 0 ? (
                spiritItems?.map((menuItem, idx) => {
                  return (
                    <SpiritsMenuListContainer
                      data={menuItem}
                      key={idx}
                      isReviewMode={true}
                      selectedItems={selectedItems}
                      handleToggleItem={handleToggleItem}
                    />
                  )
                })
              ) : (
                <Typography>
                  {searchValue ? "No items found matching your search" : "No Data Found"}
                </Typography>
              )}
            </div>
          </Container>
        </>
      )}
    </Fragment>
  )
}

export default MenuReview
